import { render, staticRenderFns } from "./FormDocumento.vue?vue&type=template&id=91fa130a&scoped=true"
import script from "./FormDocumento.vue?vue&type=script&lang=js"
export * from "./FormDocumento.vue?vue&type=script&lang=js"
import style0 from "./FormDocumento.vue?vue&type=style&index=0&id=91fa130a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91fa130a",
  null
  
)

export default component.exports